import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, forwardRef } from "react";
import { Button } from "../../components/base";
export const HotkeyButton = forwardRef(({ hotkey = "j", onTrigger, ...props }, ref) => {
    useEffect(() => {
        const down = (e) => {
            if (e.key === hotkey && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                onTrigger();
            }
        };
        if (hotkey) {
            document.addEventListener("keydown", down);
        }
        return () => {
            if (hotkey) {
                document.removeEventListener("keydown", down);
            }
        };
    }, [hotkey, onTrigger]);
    return (_jsx(Button, { ref: ref, ...props, children: props.children }));
});
HotkeyButton.displayName = "HotkeyButton";
//# sourceMappingURL=HotkeyButton.js.map